export const SET_USERS = 'SET_USERS';
export const SET_USER = 'SET_USER';
export const ADD_USER = 'ADD_USER';
export const ADD_USERS = 'ADD_USERS';
export const UPDATE_USER = 'UPDATE_USER';
export const REMOVE_USER = 'REMOVE_USER';
export const CLEAR_USER = 'CLEAR_USER';
export const CLEAR_USERS = 'CLEAR_USERS';
